import axios from "./utils/axios_fetch";
import { useEffect, useRef } from "react";
import { broadcaster, useBroadcastedState } from "./utils/events";
import { useLocation, Navigate } from "react-router";

var user = null;
var guest_user = null;
var pending_fetch_user_promise = null;
broadcaster.add_event_listener("_user_", (new_user) => {user = new_user;});

function getCurrentUser(){
    if(user){
        return Promise.resolve(user);
    }
    if(pending_fetch_user_promise){
        return pending_fetch_user_promise;
    }
    var resolver = null; 
    pending_fetch_user_promise = new Promise(
        (_resolver, reject) => { resolver = _resolver;}
    );
    
    axios.get("/user/me").then((resp) => {
        pending_fetch_user_promise = null;
        user = resp.data.user || null;  // explicitly set to null if there is no user, undefined vs null
        guest_user = resp.data.guest_user || null; // explicitly set to null if there is no user, undefined vs null  
        resolver(user || guest_user);
    });

    return pending_fetch_user_promise;
}

function useCurrentUser(){
    const [user, setUser] = useBroadcastedState("_user_");
    useEffect(
        () => {
            if(user) return;
            getCurrentUser().then((user) => setUser(user));
        }, []
    )
    return user;
}

function useUserLocationInfoFromBackend(){
    const [location_info, setLocationInfo] = useBroadcastedState("_location_info_");
    useEffect(
        () => {
            if(location_info) return;
            axios.get("/user/location").then((resp) => {
                setLocationInfo(resp.data);
            });
        }, []
    )
    return location_info;    
}

/* 
use this when you know user probably will be loaded in other api calls
so we don't need to make a duplicate parallel call to get user
*/
function useCurrentUserDelayed(){
    const [user, setUser] = useBroadcastedState("_user_");
    useEffect(
        () => {
            let timer = setTimeout(
                () => {
                    if(user) return;
                    getCurrentUser().then((user) => setUser(user));
                }, 750
            );
            return () => clearTimeout(timer);
        }, []
    )
    return user;
}


function Redirect({to, if_match, ignore }){
	const { pathname } = useLocation();
	const params = new URLSearchParams(window.location.search);
	const ctx = useRef({}).current;

	useEffect(() => {
        // If ignore pattern is provided and matches, don't redirect
		if(ignore && ignore.test(pathname)) return;
		if(if_match && !if_match.test(pathname)){window.location.href = "/not-found"; return;}

		if(ctx.redirected) return;
		ctx.redirected = true;

		if(to) params.set("path", pathname);  // custom index.html
		else {to = pathname;}  // server serves thios

		const params_str = params.toString();
		if(params_str){
			to += !to.includes("?") ? "?" : "&"; 
			to += params_str;
		}
		window.location.href = to;
	}, [pathname, if_match, ignore, to]);
	return null;
}

function NavigateWithParams({to, replace}){
	const { search } = useLocation();
	const params = new URLSearchParams(search);
	if(!to) to = params.get("path") || "/";
	params.delete("path");
	const params_str = params.toString();
	if(params_str){
		to += !to.includes("?") ? "?" : "&"; 
		to += params_str;
	}
	return <Navigate to={to} replace={replace ?? true} />;
}



export {getCurrentUser, useCurrentUser, useCurrentUserDelayed, useUserLocationInfoFromBackend, Redirect, NavigateWithParams};
